// A diacritic-insensitive scorer for cmdk's `<Command filter={…}>` prop.
//
// cmdk's built-in scorer compares the typed query against each item's `value`
// byte-for-byte after its own normalization, which does not strip diacritics:
// `defaultFilter('Grupo Día', 'grupo dia')` is 0, so the row is hidden and
// `<CommandEmpty>` renders. That is invisible to any text-level guard over our
// source, because the comparison happens inside the library.
//
// Use this only where cmdk's filtering is what narrows the list. Where the
// component or the server already filters, pass `shouldFilter={false}` instead
// so there is a single authority on which rows survive.
//
// It delegates to cmdk's own scorer on folded inputs rather than reimplementing
// the compare as `includes`, which keeps the library's fuzzy subsequence
// matching and its relative ranking — a plain substring test would silently
// drop both.

import { defaultFilter } from 'cmdk';

import { foldSearch } from './searchFold';

export function foldedCommandFilter(value: string, search: string, keywords?: string[]): number {
  return defaultFilter(foldSearch(value), foldSearch(search), keywords?.map(foldSearch));
}
